import { apiService } from "./api";

export const fileUploadService = {
  // Upload video file with progress tracking
  uploadVideo: async (file, onProgress = null) => {
    const formData = new FormData();
    formData.append("video", file);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      ...(onProgress && {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        },
      }),
    };

    try {
      const response = await apiService.post("/upload/video", formData, config);

      return response.data;
    } catch (error) {
      console.error("❌ Video upload error:", error);
      console.error("❌ Error response:", error.response);
      throw new Error(error.response?.data?.message || "Video upload failed");
    }
  },

  // Get video URL
  getVideoUrl: (filename) => {
    return `${process.env.REACT_APP_API_BASE_URL}/uploads/videos/${filename}`;
  },
};

export default fileUploadService;
